import { useEffect, useMemo } from 'react';
import {
	SHOULD_SHOW_WELCOME_ONBOARDING_MODAL,
	SHOWED_WELCOME_ONBOARDING_MODAL_DURING_SIGNUP,
} from '@atlassian/jira-onboarding-core/src/constants.tsx';
import { sessionStorageProvider } from '@atlassian/jira-onboarding-core/src/utils/index.tsx';
import type { ModalSource } from '../../common/types.tsx';
import { useCanShowNudgeTour } from '../../common/use-can-show-nudge-tour.tsx';

export const useShouldShowModalBasedOnSessionStorage = (): boolean => {
	const shouldShowModalBasedOnSessionStorage = useMemo(() => {
		const isWizardDuringSignup = sessionStorageProvider.get(
			SHOWED_WELCOME_ONBOARDING_MODAL_DURING_SIGNUP,
		);
		if (isWizardDuringSignup) {
			return false;
		}

		const sessionStorageVal = sessionStorageProvider.get(SHOULD_SHOW_WELCOME_ONBOARDING_MODAL);

		if (sessionStorageVal === undefined) {
			return false;
		}

		return true;
	}, []);

	useEffect(() => {
		// Remove the session storage value to prevent the modal showing again
		sessionStorageProvider.remove(SHOULD_SHOW_WELCOME_ONBOARDING_MODAL);
	}, []);

	return shouldShowModalBasedOnSessionStorage;
};

export const useShouldShowWelcomeModal = (source: ModalSource): boolean => {
	const canShowNudgeTour = useCanShowNudgeTour();
	const sessionStorageVal = useMemo(
		() => sessionStorageProvider.get(SHOULD_SHOW_WELCOME_ONBOARDING_MODAL),
		[],
	);

	const isWizardDuringSignup = sessionStorageProvider.get(
		SHOWED_WELCOME_ONBOARDING_MODAL_DURING_SIGNUP,
	);
	if (isWizardDuringSignup) {
		return false;
	}

	if (sessionStorageVal === undefined) {
		return false;
	}

	return canShowNudgeTour(source);
};
